import React from 'react';
import { PropTypes} from 'prop-types';

import { Dropzone } from '../dropzone/dropzone.jsx';
import { observer } from 'mobx-react';

@observer
export default class IconDropzone extends React.Component {

    static propTypes = {
        newAppMasterStore: PropTypes.object.isRequired,
        uploadImmediately: PropTypes.bool,
        disabled: PropTypes.bool,
        saveRef: PropTypes.func,
        wasEdited: PropTypes.bool,
        readOnly: PropTypes.bool
      }
    
    static defaultProps = {
        uploadImmediately: true,
        disabled: false,
        saveRef: () => {},
        wasEdited: false,
        readOnly: false
    }

  constructor(props) {
    super(props);
    this.references = {};
  }

  handleUplodIcon = (event) => {
    this.props.newAppMasterStore.newAppUploadStore.handleScreenshotUpload(event, 'icon', this.props.uploadImmediately)
  }

  handleRemoveIcon = () => {
    if (!this.props.disabled) {
      this.props.newAppMasterStore.newAppUploadStore.removeScreenshot(0, 'icon');
    }
  }

  wasEditedClass = () => {
    if(this.props.readOnly && this.props.wasEdited) {
      return 'was-edited'
    }
  }
  
  renderAppIconSection = () => {
    const appIcon = this.props.newAppMasterStore.newAppUploadStore.screens.icon;
    if (appIcon.length > 0) {
      let screen = appIcon[0];
      return (<div className={`app-icon ${this.wasEditedClass()}`}>
        <img alt="appIcon" className={`icon-image ${(screen.isUploading)
          ? 'uploading'
          : ''}`} src={screen.imageURL} />
        {screen.isUploading && <div className="progress loading-indicator">
          <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow={screen.progress} aria-valuemin="0" aria-valuemax="100" style={{
            width: `${screen.progress}%`
          }}>
            <span className="sr-only">{`${screen.progress}% Complete`}</span>
          </div>
        </div>}
        {!this.props.readOnly &&
          <button ref={(i) => this.references['appIconDeleteButton'] = i} className="btn fn-hi-contrast delete-button" onClick={this.handleRemoveIcon} disabled={this.props.disabled}>
            <span className="sr-only">Remove app icon</span>
            <span className="icon-trash white"></span>
          </button>
        }
      </div>);
    } else {
      return (
        <Dropzone
          refName="appIconBrowserButton"
          saveRef={this.props.saveRef}
          disabled={this.props.disabled}
          onUpload={this.handleUplodIcon}
          errorText={this.getErrorMessage('icon')}
          hasError={Boolean(this.getErrorMessage('icon'))} />
      )
    }
  }

  getErrorMessage = (deviceType) => {
    if (this.props.newAppMasterStore.newAppUploadStore.invalidUploadAttempted[deviceType] === 1) {
      return this.props.newAppMasterStore.PNG_ERROR;
    } else if (this.props.newAppMasterStore.newAppUploadStore.invalidUploadAttempted[deviceType] === 2) {
      return this.props.newAppMasterStore.DIMENSIONS_ERROR;
    } else if (this.props.newAppMasterStore.masterStateProps.errorsAreDisplayed && this.props.newAppMasterStore.newAppDetailsStore[`${deviceType}ScreensAreMissing`]) {
      return this.props.newAppMasterStore.REQUIRED_ERROR;
    }
    return '';
  }

  render() {
    return(
        <div className="row screenshot-dropzone-section">
          <div className="col-3 form-group">
            <label className="col-form-label image-label" id="iconScreenshotUploadDescription">
              <span className="required">High-resolution icon</span>
              <span className="sr-only">This is a required field</span>
              <br />
              <span className="help-text as-block">
                <div>PNG only</div>
                <div>Size: 512x512px</div>
                <div>Visible only to you. Users will see the icon from the app package.</div>
              </span>
            </label>
          </div>
          <div className="form-group col-5">
            {this.renderAppIconSection()}
          </div>
        </div>
    )
  }
}
